import React from "react";
// ANT DESIGN COMPONENTS
import { Tag } from "antd";
// FLATBUFFER TYPES
import { LiftType } from "../../../flatbuffers/generated/archive/lift-type";
import { liftTypeLabel } from "../../../flatbuffers/display";

function TableColumnLiftType({ liftType }: { liftType: LiftType }) {
  const label = liftTypeLabel(liftType);

  const colorMap: Record<LiftType, string> = {
    [LiftType.ELEVATOR]: "blue",
    [LiftType.ESCALATOR]: "orange",
    [LiftType.MOVINGWALK]: "green",
    [LiftType.BOT]: "purple",
    [LiftType.GPIO]: "gray",
  };

  return (
    <div>
      <Tag color={colorMap[liftType] ?? "red"} className="drawer__typeTag">
        {label || "N/A"}
      </Tag>
    </div>
  );
}

export default TableColumnLiftType;
